import { Card, CardActionArea, CardHeader } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { Contract } from "../../app/backendTypes";
import Avatar from "../common/Avatar";

export default function ContractCard(props: { contract: Contract }) {
  const { contract } = props;

  return (
    <Card>
      <CardActionArea component={RouterLink} to={`/contracts/${contract.id}`}>
        <CardHeader
          title={contract.name}
          subheader={contract.short_desc}
          avatar={<Avatar alt={contract.name} src={contract.avatar} />}
        />
      </CardActionArea>
    </Card>
  );
}
